export default "__VITE_ASSET__357p1l2x__"